module.exports = __webpack_public_path__ + "img/20180218_085217-min.7799ae92.jpg";